export default function ($http) {
    return function (vehicleId, vehicleModel) {
        return $http.put(`api/vehicles/${vehicleId}`, vehicleModel);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/vehicles/updateVehicle.js